var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInicioFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico / Bottom Nav / large / inicio-full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7184983,2.11966373 C11.8695272,1.96011209 12.1306812,1.96011209 12.28171,2.11966373 L12.28171,2.11966373 L14.6226566,4.59170432 L19.8667127,10.1527858 L21.9003576,12.306733 C22.1227056,12.5420212 21.948603,12.9186842 21.6182274,12.9186842 L21.6182274,12.9186842 L20.3827278,12.9186842 L20.3827278,21.6324253 C20.3827278,21.8364091 20.2128204,22 20.0020093,22 L20.0020093,22 L14.4768718,22 C14.2660608,22 14.0961534,21.8364091 14.0961534,21.6324253 L14.0961534,21.6324253 L14.0961534,14.9363056 L9.90405494,14.9363056 L9.90405494,21.6324253 C9.90405494,21.8364091 9.73309871,22 9.52333647,22 L9.52333647,22 L3.99819898,22 C3.78738792,22 3.61643169,21.8364091 3.61643169,21.6324253 L3.61643169,21.6324253 L3.61643169,12.9186842 L2.38198089,12.9186842 C2.05055655,12.9186842 1.8775027,12.5420212 2.09985067,12.306733 L2.09985067,12.306733 Z M18.4994786,2 C18.7760167,2 19,2.2036405 19,2.45506257 L19,2.45506257 L19,8 L13,2 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico-/-Bottom-Nav-/-large-/-inicio-full",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicioFull);
export default __webpack_public_path__ + "static/media/inicio-full.47a8c5dc5470521f21590fdd7f3c81e2.svg";
export { ForwardRef as ReactComponent };